import { render, staticRenderFns } from "./SimpleStackedBar.vue?vue&type=template&id=1e491056&scoped=true&"
import script from "./SimpleStackedBar.vue?vue&type=script&lang=js&"
export * from "./SimpleStackedBar.vue?vue&type=script&lang=js&"
import style0 from "./SimpleStackedBar.vue?vue&type=style&index=0&id=1e491056&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e491056",
  null
  
)

export default component.exports